export default {
  lines: [

    {
      character: 'player',
      text: 'Mikhail? Do you copy?'
    },

    {
      character: 'instructor',
      text: 'I can hear you. Not over the radio but I\'m listening to the intercom'
    },

    {
      character: 'player',
      text: 'Ok... I\'ll try to fix the radio on this side. Is the unit ok on your end?'
    },

    {
      character: 'instructor',
      text: 'It looks fine, Johan. The light is on, I can see the frequency but nothing is happening when you transmit.'
    },

    {
      character: 'player',
      text: 'What is the frequency?'
    },

    {
      character: 'instructor',
      text: '142.10'
    }

    // FIXME: dialog tree?
    // {
    //   character: 'player',
    //   options: [
    //     'Looks like I have the wrong frequency here. My radio only goes up to 40. Hold on, let me try to get the other one working.',
    //     'Try lowering the frequency to 80'
    //   ]
    // }

    // FIXME: new dialog when player can proceed?

  ]
}
